import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.928 3.727h-2.85l-1.31-1.3a.749.749 0 0 0-.53-.22h-3.16a2.623 2.623 0 0 0-2.62 2.62v6.34a2.623 2.623 0 0 0 2.62 2.62h7.85a2.623 2.623 0 0 0 2.62-2.62v-4.82a2.623 2.623 0 0 0-2.62-2.62Zm1.12 7.44a1.118 1.118 0 0 1-1.12 1.12h-7.85a1.118 1.118 0 0 1-1.12-1.12v-6.34a1.125 1.125 0 0 1 1.12-1.12h2.85l1.31 1.3a.749.749 0 0 0 .53.22h3.16a1.118 1.118 0 0 1 1.12 1.12Z';
const draw24px =
  'M18,20.45H6a3.6,3.6,0,0,1-3.6-3.6V7.15A3.6,3.6,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.12,2.1H18a3.61,3.61,0,0,1,3.6,3.61v7.37A3.6,3.6,0,0,1,18,20.45ZM3.89,9.48v7.37A2.1,2.1,0,0,0,6,19H18a2.1,2.1,0,0,0,2.1-2.1V9.48A2.1,2.1,0,0,0,18,7.37H13.17a.75.75,0,0,1-.53-.22l-2.12-2.1H6a2.1,2.1,0,0,0-2.1,2.1Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FolderIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'folder'),
) as IconWithRender;

FolderIcon.displayName = 'FolderIcon';
FolderIcon.propTypes = Icon.propTypes;
FolderIcon.renderIcon = (props) => <FolderIcon {...props} />;
export default FolderIcon;
